import { HttpClient } from '@angular/common/http';
import { Data, Response, waitAndRetry } from '@dimandzhi/graphql';
import { currentMethodName } from 'app/current-method-name';
import { GraphQL } from 'app/graphql';
import { environment as env } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

export class UserGroups {
  private userGroupsFirstCall: boolean;
  private userGroups: BehaviorSubject<GraphQL.UserSchema.UserGroup[]>;

  constructor(
    protected http: HttpClient
  ) { }

  initUserGroups() {
    this.userGroupsFirstCall = true
    this.userGroups = new BehaviorSubject<GraphQL.UserSchema.UserGroup[]>([]);
  }

  getUserGroups(): Observable<GraphQL.UserSchema.UserGroup[]>;
  getUserGroups(asSnapshot: boolean): GraphQL.UserSchema.UserGroup[];
  getUserGroups(asSnapshot?: boolean) {
    if (this.userGroupsFirstCall) {
      this.refreshUserGroups();
      this.userGroupsFirstCall = false;
    }
    if (asSnapshot) {
      return this.userGroups.getValue();
    }
    return this.userGroups.asObservable();
  }

  private refreshUserGroups() {
    this.http.post<Response>(`${env.graphqlUser}/${currentMethodName()}`, `
        query {
          UserGroup {
            id
            name
          }
        }`
    ).pipe(waitAndRetry, Data.fromResp).subscribe({
      next: data =>
        this.userGroups.next(GraphQL.UserSchema.UserGroup.fromData(data)),
      error: err => this.userGroups.error(err)
    });
  }
}
